import React from 'react';
import TableCell from '@material-ui/core/TableCell';
import { withStyles } from '@material-ui/core/styles';
import { getCustomStyles } from '@defi/core-utils';
import DataElement from './DataElement';
import { fromJS } from 'immutable';
var styles = {
  cell: {
    whiteSpace: 'normal',
    textOverflow: 'ellipsis',
    padding: '0px 24px',
    overflow: 'hidden',
    fontSize: 12,
    height: 30
  },
  empty: {
    fontSize: 12,
    height: 1
  },
  required: {
    color: 'red',
    fontWeight: 'bold'
  },
  bold: {
    fontWeight: 'bold'
  }
};

var replacePath = function replacePath(path) {
  return path.replace('/Underwriter/LoanApplications/Index/?loanApplicationID=', '');
};

var renderLink = function renderLink(cell) {
  return React.createElement("a", {
    href: cell.getIn(['DataElement', 'TargetUrl']),
    target: cell.getIn(['DataElement', 'Target']),
    "data-testid": "hyperlink-cell"
  }, cell.getIn(['DataElement', 'DisplayText']));
};

var renderDupAppLink = function renderDupAppLink(cell) {
  return React.createElement("span", null, React.createElement("div", {
    "data-testid": "dupAppLink-cell",
    dangerouslySetInnerHTML: {
      __html: replacePath(cell.get('Value'))
    }
  }));
};

var Cell = function Cell(props) {
  var _props$children = props.children,
      children = _props$children === void 0 ? fromJS({}) : _props$children,
      classes = props.classes;
  var cellStyle = children.has('Value') && children.get('Value') !== '' ? classes.cell : classes.empty;
  var elementId = children.get('ElementId') || '';

  var renderStaticText = function renderStaticText() {
    return React.createElement("span", null, React.createElement("div", {
      title: children.get('Value'),
      className: classes.bold,
      "data-testid": "static-cell"
    }, children.get('Value'), children.get('IsRequired') && props.editStatus && React.createElement("span", {
      className: classes.required
    }, " *")));
  };

  var getStaticType = function getStaticType() {
    if (children.get('Type') === 'StaticValue') {
      return renderStaticText();
    }

    if (children.has('Value') && children.get('Value')[0] === '<') {
      return renderDupAppLink(children);
    }

    return null;
  };

  var getElementType = function getElementType() {
    var element = children.get('DataElement');

    if (element.get('DataType') === 'HyperLink' && element.get('IsOldLinkField')) {
      return renderLink(children);
    }

    if (children.get('IsReadOnly')) {
      return React.createElement("span", {
        "data-testid": "readonly-element"
      }, React.createElement("div", {
        title: children.get('Value')
      }, children.get('Value')));
    }

    return React.createElement(DataElement, {
      "data-testid": "data-element"
    }, children);
  };

  return React.createElement(TableCell, {
    className: "".concat(cellStyle, " ").concat(elementId),
    style: getCustomStyles(children.get('Format')),
    "data-testid": "cell"
  }, children.get('Type') === 'DataElement' ? getElementType() : getStaticType());
};

export default withStyles(styles)(Cell);